import { IntlShape } from 'react-intl';
import { messages } from './messages';

const Schema = (intl: IntlShape) => ({
  title: intl.formatMessage(messages.ResearchFocus),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['research_focus'],
    },
  ],
  properties: {
    research_focus: {
      title: intl.formatMessage(messages.ResearchFocus),
      description: intl.formatMessage(messages.ResearchFocusHelp),
      widgetOptions: {
        frontendOptions: {
          widget: 'object_browser',
          widgetProps: {
            selectableTypes: ['ResearchFocus'],
          },
        },
      },
      default: [],
    },
  },
  required: [],
});

export default Schema;
